import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Daniel Williams', 
        title: 'Homeowner',
        content: 'Switching to Sunspot Solar completely transformed my energy bills. The installation was smooth, and now my home runs efficiently on clean, renewable power.'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'Olivia Thompson', 
        title: 'Eco-Conscious Traveler',
        content: "I wanted to reduce my carbon footprint, and Sunspot made it possible. Their solar panels are both high-performing and aesthetically pleasing."
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Ethan Carter', 
        title: 'Small Business Owner',
        content: 'Installing solar panels with Sunspot was the best investment for my business. Energy costs have dropped significantly, and customers appreciate our commitment to sustainability.'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Sophia Reynolds', 
        title: 'Environmental Advocate',
        content: "Sunspot’s team was professional and informative every step of the way. I feel proud knowing my energy is coming from a clean and renewable source."
    },
];

export default testimonials;